<div class="row mb-3">
  <div class="col">
    <rask-textarea
      aid="aoAnteckning"
      class="w-100"
      label="Anteckning till avverkningsdirektiv och maskinens apteringsfiler"
      [rows]="5"
      [(ngModel)]="arbetsorder.anteckningProduktionsplanering"
      (change)="updateAOAnteckningProduktionsplanering()"
      [disabled]="!isDetailEditable()"
      [maxlength]="prodPlanMaxLength">
    </rask-textarea>
  </div>
</div>
@for (anteckning of anteckningar; track anteckning) {
  <div class="row mt-2">
    <div class="col">
      <rask-textmultiline [label]="anteckning.typ">
        <strong>{{getBeteckningarFromAtgarder(anteckning.atgarder)}}</strong>
        <div>{{anteckning.anteckning}}</div>
      </rask-textmultiline>
    </div>
  </div>
}
@if (!arbetsorder.viol3) {
  <div class="row">
    <div class="col">
      <rask-textarea
        id="inputAnteckningVirkesorder"
        class="w-100"
        label="Anteckning till virkesordern"
        [rows]="1"
        [(ngModel)]="arbetsorder.anteckningVirkesorder"
        (change)="arbetsorderAnteckningVirkesorderUpdated()"
        [disabled]="!isDetailEditable()"
        [maxlength]="arbetsorderAnteckningVirkesorderMaxLength">
      </rask-textarea>
    </div>
  </div>
}